export enum AccountType {
    individual = "INDIVIDUAL",
    joint = "JOINT",
}

export enum AccountTypes { 'Account Holder', 'Joint', 'POA', 'Others' }
export enum DocumentTypes { 'Citizenship', 'Passport', 'National Identity', 'Driving License', 'Pan', 'Others' }
export enum RelationShip {
    Father,
    Mother,
    Son,
    Daughter,
    Spouse,
    Others,
}
export enum LockerStatus {
    Available,
    InProcess,
    Occupied,
    Blocked,
    InRepair,
    Closed,
    Damaged,
    Saved,
    Approved
}
export enum Roles { 'maker', 'checker', 'admin' }
